<!--
 * @Author: Latte
 * @Date: 2021-08-04 16:43:05
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-01 14:36:17
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\MyTable\MyPagination\index.vue
-->
<template>
  <div class="container">
    <el-pagination
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :current-page="pageOpt.currentPage"
      :page-size="pageOpt.pageSize"
      :total="pageOpt.totalCount"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "MyPagination",
  inject: {
    pageOpt: {
      default: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      }
    }
  },
  methods: {
    // 当前页数改变
    handleCurrentChange(val) {
      this.pageOpt.currentPage = val
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: right;
}
</style>
